import React from 'react'
import Label from 'src/components/Label'

export const CategoryGroupId = {
  PRODUCT: 2,
  SERVICE: 2,
  CASH_IN_REASON: 3,
  CASH_OUT_REASON: 4,
  1: 'PRODUCT',
  2: 'SERVICE',
  3: 'CASH_IN_REASON',
  4: 'CASH_OUT_REASON',
}

export const getCourseGroupIdLabel = (Status) => {
  const CourseGroupId = {
    1: {
      text: 'INDIVIDUAL',
      color: 'info',
    },
    2: {
      text: 'JOINT',
      color: 'info',
    },
    3: {
      text: 'GUEST',
      color: 'info',
    },
    INDIVIDUAL: {
      id: 1,
    },
    JOINT: {
      id: 2,
    },
    GUEST: {
      id: 3,
    },
  }

  const { text, color } = CourseGroupId[Status]
  return <Label color={color}>{text}</Label>
}

export const CourseGroupId = {
  OPEN_CASE: 1,
  OPEN_CARD: 2,
  OPEN_CHECKOUT: 3,
  1: 'OPEN_CASE',
  2: 'OPEN_CARD',
  3: 'OPEN_CHECKOUT',
}
